module.exports = __webpack_public_path__ + "img/ward.5d6e32d9.png";